module.exports = __webpack_public_path__ + "img/game.bb4ed0ad.svg";